import { render } from "./Profile.vue?vue&type=template&id=34b1920b&ts=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\wotruba\\IdeaProjects\\fungus_data_tool\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__